export class ICalendar {
  id: number;
  summary: string;
  start: string;
  end: string;
  location: string;
  description: string;
}
